var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import configPathActions from "../actions/ConfigPathActions.js";
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
import * as _ from "lodash";
import { getDefaultAsyncWrapperObj, AsyncRequestStatus, getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
const initialState = {
  allPaths: [],
  paths: [],
  rootPath: getDefaultAsyncWrapperObj(),
  selectedPath: "",
  experimentationGroupId: "",
  diffPath: "",
  isLoading: false,
  error: ""
};
class ConfigPathReducer {
  loadingRootPath(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      rootPath: { status: AsyncRequestStatus.Pending }
    });
  }
  loadedRootPath(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      rootPath: getCompletedAsyncWrapperObj(action.payload, ""),
      diffPath: action.payload
    });
  }
  getPaths(state, action) {
    if (action.error === true) {
      return __spreadProps(__spreadValues({}, state), {
        error: action.payload
      });
    }
    return __spreadProps(__spreadValues({}, state), {
      paths: action.payload
    });
  }
  getAllPaths(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      allPaths: action.payload
    });
  }
  selectPath(state, action) {
    const rootPath = state.rootPath.data;
    let selectedPath = action.payload.selectedPath || rootPath;
    selectedPath = selectedPath.startsWith("/") && selectedPath !== "/" ? selectedPath.substring(1) : selectedPath;
    let parentPath = selectedPath ? selectedPath.split("/").slice(0, -1).join("/") : rootPath;
    if (parentPath === "") {
      parentPath = rootPath;
    }
    return __spreadProps(__spreadValues({}, state), {
      selectedPath,
      experimentationGroupId: action.payload.experimentationGroupId,
      diffPath: parentPath
    });
  }
  setIsHidden(state, action) {
    const index = _.findIndex(state.allPaths, (p) => p.path === action.payload.path);
    const newState = __spreadProps(__spreadValues({}, state), {
      allPaths: [...state.allPaths]
    });
    newState.allPaths[index] = action.payload;
    return newState;
  }
  selectDiffPath(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      diffPath: action.payload
    });
  }
}
const reducer = createReducer(configPathActions, new ConfigPathReducer(), initialState);
export {
  ConfigPathReducer,
  reducer as default
};
//# sourceMappingURL=ConfigPathReducer.js.map
